import { createInstance } from 'i18next';
import LocizeBackend from 'i18next-locize-backend';
import LastUsed from 'locize-lastused';
import { initReactI18next } from 'react-i18next';
import { Languages, LOCIZE_NS } from './constants/common';

const locizeOptions = {
  projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
  apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
  referenceLng: Languages.Spanish,
  version: import.meta.env.VITE_LOCIZE_VERSION ?? 'prod',
};

export const i18n = createInstance();
const isProduction = import.meta.env.PROD;

if (!isProduction) {
  i18n.use(LastUsed);
}

i18n
  .use(LocizeBackend)
  .use(initReactI18next)
  .init({
    supportedLngs: [Languages.Spanish, Languages.English, Languages.Catalan],
    ns: Object.values(LOCIZE_NS),
    defaultNS: LOCIZE_NS.COMMON,
    fallbackLng: Languages.Spanish,
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
    partialBundledLanguages: true,
    ...(isProduction
      ? {}
      : {
          locizeLastUsed: {
            projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
            apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
            referenceLng: Languages.Spanish,
            version: import.meta.env.VITE_LOCIZE_VERSION ?? 'prod',
            debounceSubmit: 90000,
          },
        }),
  });

export const t = i18n.t.bind(i18n);
export const tExists = (key: string): boolean => i18n.exists(key);
